import { axios } from '@Root/API'

export const remove = studentTypeId => {
	return axios.delete(`student-types/delete/${studentTypeId}`)
}
